import script from "./LabelConfirmationInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelConfirmationInput.vue?vue&type=script&setup=true&lang=ts"

import "./LabelConfirmationInput.vue?vue&type=style&index=0&id=6269ef52&lang=scss&scoped=true"
import "./LabelConfirmationInput.vue?vue&type=style&index=1&id=6269ef52&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6269ef52"]])

export default __exports__